import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useSchedulesList(filters = {}) {
    return useQuery({
        queryKey: ['schedules', filters],
        queryFn: () => {
            const params = new URLSearchParams();
            if (filters.month)
                params.set('month', String(filters.month));
            if (filters.year)
                params.set('year', String(filters.year));
            if (filters.oppositionId)
                params.set('opposition_id', filters.oppositionId);
            if (filters.shiftId)
                params.set('shift_id', filters.shiftId);
            const qs = params.toString();
            return apiClient(`/schedules${qs ? `?${qs}` : ''}`);
        },
        staleTime: 1000 * 60 * 2,
    });
}
export function useScheduleDetail(id) {
    return useQuery({
        queryKey: ['schedule-detail', id],
        queryFn: () => apiClient(`/schedules/${id ?? ''}`),
        enabled: !!id,
        staleTime: 1000 * 60 * 2,
    });
}
export function useCreateSchedule() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/schedules', { method: 'POST', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['schedules'] }),
    });
}
export function usePublishSchedule(id) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => apiClient(`/schedules/${id}/publish`, { method: 'POST' }),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['schedules'] });
            void queryClient.invalidateQueries({ queryKey: ['schedule-detail', id] });
        },
    });
}
export function useUnpublishSchedule(id) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => apiClient(`/schedules/${id}/unpublish`, { method: 'POST' }),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ['schedules'] });
            void queryClient.invalidateQueries({ queryKey: ['schedule-detail', id] });
        },
    });
}
export function useDeleteSchedule() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiClient(`/schedules/${id}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['schedules'] }),
    });
}
export function useAddClass(scheduleId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient(`/schedules/${scheduleId}/classes`, {
            method: 'POST',
            body: JSON.stringify(dto),
        }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['schedule-detail', scheduleId] }),
    });
}
export function useRemoveClass(scheduleId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (classId) => apiClient(`/schedules/${scheduleId}/classes/${classId}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['schedule-detail', scheduleId] }),
    });
}
export function useUpdateClass(scheduleId) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ classId, ...dto }) => apiClient(`/schedules/${scheduleId}/classes/${classId}`, {
            method: 'PATCH',
            body: JSON.stringify(dto),
        }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['schedule-detail', scheduleId] }),
    });
}
//# sourceMappingURL=useSchedules.js.map